
define('modules/application/wizard/classes/remoteControls',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {

  var remoteControlModel        = Backbone.Model.extend({

    initialize                : function() {
      this.set("products", undefined);
      if (!this.get("value"))
        this.set("value", 0);

      this.unbind("change:value", this.valueChangedEventHandler);
      this.bind("change:value", this.valueChangedEventHandler, this);
    },

    decrementValue            : function() {
      var currentValue = this.get("value");
      if (currentValue-1>=0) {
        this.set("value", (currentValue-1));
      }
    },

    incrementValue            : function() {
      var currentValue = this.get("value");
      this.set("value", (currentValue+1));
    },

    resetValue                : function() {
      this.set("value", 0);
    },

    valueChangedEventHandler  : function() {
      this.trigger("value:changed");
      this.get("sectionEventAggregator").trigger("value:changed");
    }
  });

  var remoteControlView         = Backbone.View.extend({
    tagName  : "section",
    className: "remoteControl",
    template : "application/wizard/sections/remoteControls/item",
    events   : {
      "click .ui-spinner-down" : "decrementValue",
      "click .ui-spinner-up"   : "incrementValue"
    },

    serialize                       : function() {
      return {model : this.model, app : app};
    },

    initialize                      : function() {
      this.model.unbind("value:changed", this.updateSpinners);
      this.model.bind("value:changed", this.updateSpinners, this);
    },

    decrementValue                  : function() {
      this.model.decrementValue();
    },

    incrementValue                  : function() {
      this.model.incrementValue();
    },

    updateSpinners                  : function() {
      this.$el.find(".mainValue .spinner").html(this.model.get("value"));
    }
  });

  var remoteControlPackageModel = Backbone.Model.extend({

    initialize                      : function() {
      this.retrieveProducts();
    },

    retrieveProducts                : function() {
      var that=this;
      BticinoS4B.Instances.Models.ApplicationModel.getProducts(this.get("packageClassId"), function(data) {
        data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
        that.set("products", _.filter(data.products, function(product) {return (product.mnemonic===1);}).splice(0,1));

        var products                = _.extend(that.get("products")), productsLength = products ? products.length : 0;
        var productsToReAdd         = [];
        var eventAggregator         = that.get("sectionEventAggregator");
        for (var i=0; i<productsLength; i++)
          productsToReAdd.push(new remoteControlModel(_.extend(_.extend(that.attributes, products[i]), {sectionEventAggregator : eventAggregator})));

        that.set("products", productsToReAdd);

        var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==4);})[0];

        that.set("secondaryProducts", secondaryProducts);
      });
    },

    assignValues                    : function(value) {
      var products = this.get("products"), productsLength = products ? products.length : 0;
      for (var i=0; i<productsLength; i++) {
        products[i].set("value", value);
      }
    },

    resetProductsValue              : function() {
      var products = this.get("products"), productsLength = products ? products.length : 0;
      for (var i=0; i<productsLength; i++) {
        products[i].resetValue();
      }
    }
  });

  var remoteControlPackageView  = Backbone.View.extend({
    tagName  : "section",
    className: "remoteControlPackage",

    serialize    : function() {
      return {model : this.model, app : app};
    },

    beforeRender : function() {
      var products = this.model.get("products"), productsLength = products ? products.length : 0;
      for(var i=0; i<productsLength; i++)
        this.insertView(new remoteControlView({model : products[i]}));
    }

  });

  var remoteControls            = _.extend({}, genericElement, {

    Views       : {

      titleBar  : genericElement.Views.titleBar.extend({

        template: "application/wizard/sections/remoteControls/titleBar",
        tagName : "h3",

        initialize                     : function() {

          this.model.unbind("updateViews", this.setLabel);
          this.model.bind("updateViews", this.setLabel, this);
          this.model.get("sectionEventAggregator").unbind("value:changed", this.setLabel);
          this.model.get("sectionEventAggregator").bind("value:changed", this.setLabel, this);

          this.model.set("titleBarView",this);
        },

        setLabel                      : function() {
          var remotes = this.model.get("remotes"), remotesLength = remotes ? remotes.length : 0, remotesAmount = 0, remotesType;
          var products, productsLength;
          var remotesTypeLabel;

          for (var i=0; i<remotesLength; i++) {
            if (i===0)
              remotesType = remotes[i].get("type");

            products       = remotes[i].get("products");
            productsLength = products ? products.length : 0;

            for (var j=0; j<productsLength; j++) {
              remotesAmount += products[j].get("value");
            }
          }

          if (remotesAmount>0)
          {
            if (remotesType==="tp")
              remotesTypeLabel = "IDS_WAI1001_9004";
            else if (remotesType==="ir")
              remotesTypeLabel = "IDS_WAI1001_9005";

            this.$el.find(".caption").html(remotesAmount + " " + $.i18n._(remotesTypeLabel))  ;
            this.$el.find(".caption").fadeIn(200);
          }
          else
            this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        enable                        : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeIn(200);
        },

        disable                       : function() {
          this.$el.trigger("click");
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel                   : function() {
          this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        onClose: function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      }),

      content   : genericElement.Views.content.extend({
        template                      : "application/wizard/sections/remoteControls/content",
        className                     : "remoteControls",
        events                        : {
          "click .radio"            : "typeSelectorChangedEventHandler",
          "click .toggleInfoButton" : "toggleInfos"
        },

        serialize                     : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        initialize                    : function() {
          this.model.bind("render:requested", this.renderRequestedEventHandler, this);
          this.model.bind("change:type", this.typeChangedEventHandler, this);
          this.model.set("contentView",this);
        },

        toggleInfos : function(e) {
          return genericElement.Views.content.prototype.toggleInfos(e, this);
        },

        renderRequestedEventHandler   : function() {
          this.render();
        },

        beforeRender   : function() {
          var i=0;
          var subViews        = this.getViews().__wrapped__;

          for (i=0; i<subViews.length; i++)
            subViews[i].remove();

          var remoteControls  = [];
          var originalRemotes = this.model.get("fetchedRemotes");

          if (originalRemotes)
            for (i=0; i<originalRemotes.length; i++) {
              remoteControls.push(_.extend({}, originalRemotes[i]));
            }

          var remoteControlsLength = remoteControls ? remoteControls.length : 0;
          var transponders         = _.filter(remoteControls, function(remotePackage) {return remotePackage.get("type")==="tp";});
          var infrareds            = _.filter(remoteControls, function(remotePackage) {return remotePackage.get("type")==="ir";});

          if ((transponders.length>0)&&(infrareds.length>0)) {
            remoteControls        = this.model.get("remotes");
            remoteControlsLength  = remoteControls.length;
            this.showSelector();
          }
          else {
            this.hideSelector();
            if (transponders.length>0)
              this.selectType("tp");
            if (infrareds.length>0)
              this.selectType("ir");
          }

          for (i=0; i<remoteControlsLength; i++)
            this.insertView(new remoteControlPackageView({model : remoteControls[i]})).render();
        },

        typeChangedEventHandler         : function(model)  {
          this.$el.find("input").removeAttr("rel");
          this.$el.find("input").removeAttr("checked");

          this.$el.find("input[value='"+this.model.get("type")+"']").attr('checked', true);
          this.$el.find(".radio").remove();
          window.customizeFormElements.call();
        },

        showSelector                    : function()  {
          this.$el.find(".remotesType").show();
        },

        hideSelector                    : function()  {
          this.$el.find(".remotesType").hide();
        },

        selectType                      : function(type) {
          var choosenSelector = this.$el.find("input[val='"+type+"']").trigger("click");
          window.customizeFormElements.call();
        },

        typeSelectorChangedEventHandler : function(e) {
          var value = this.$el.find("input[name='remotesType']:checked").val();
          this.model.set("type", value);
        },

        disableSection                 : function() {
          if (!this.model.get("enabled"))
            this.$el.find(".mainValue").addClass("disabled");
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
            this.$el.find(".mainValue").removeClass("disabled");
        },

        isOpen                         : function()          {
          return this.$el.css("display")=="block";
        },

        //Retrieve and set the accessory line's details
        afterRender                    : function()         {

          this.$el.find("h4.mainTitle").html($.i18n._(this.model.get("wizardChoiceLabel")));
          //

          if (this.model.get("wizardChoiceDescription")) {
            if ($.i18n._(this.model.get("wizardChoiceDescription")).length>360)
            {
              this.$el.find(".description.mainElement").text($.i18n._(this.model.get("wizardChoiceDescription")).substring(0, 360));
              this.$el.find(".description.mainElement").append("<br /><br /><span class='tooltip'>"+$.i18n._("IDS_W1_9032")+" ›</span>");
              this.$el.find(".tooltip.mainElement").qtip({
                content   : $.i18n._(this.model.get("wizardChoiceDescription")),
                show      : 'click',
                style     : {
                  classes  : 'ui-tooltip-shadow'
                },
                position  : {
                  at: 'center left',
                  my: 'center right'
                },
                effect    : function() { $(this).fadeIn(200); }
              });
            }
            else
              this.$el.find(".description.mainElement").text($.i18n._(this.model.get("wizardChoiceDescription")));
          }

          
        },

        onClose                        : function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      })
    },

    Model       : genericElement.Model.extend({

      defaults                        : {
        enabled         : false,
        type            : "tp"
      },

      initialize                      : function() {
        var that = this;

        //Bind on main control unit selection
        this.attributes.stepEventAggregator.bind('mainControlUnit:chosen', function(mainControlUnitId)  {
          that.set("enabled", true);
          that.retrievePackages(mainControlUnitId);
          that.trigger("render:requested");
        });

        //Bind on main control unit removal
        this.attributes.stepEventAggregator.bind('mainControlUnit:removed', function()      {
          that.set("enabled", false);
          that.disableSection();
          that.trigger("render:requested");
        });

        this.unbind("change:type",                this.filterPackages);
        this.bind("change:type",                  this.filterPackages, this);

        this.unbind("change:loadedModel",         this.changeLoadedModelEventHandler);
        this.bind("change:loadedModel",           this.changeLoadedModelEventHandler, this);

        window.BticinoS4B.eventAggregator.bind("load:Project",  this.loadProject, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",this.deliverModel, this);

        var eventAggregator         = _.extend({}, Backbone.Events);
        this.set("sectionEventAggregator", eventAggregator);
      },

      changeLoadedModelEventHandler   : function(e) {
        if(this.get("loadedModel"))
          this.filterPackages();
      },

      filterPackages                  : function() {
        var i                  = 0;
        var type               = this.get("type");
        var remotes            = this.get("fetchedRemotes");
        var currentModelToLoad = this.get("loadedModel");

        var filteredRemotes       = _.filter(remotes, function(remote){
          remote.resetProductsValue();
          return (remote.get("type")===type);
        });

        var filteredRemotesLength = filteredRemotes.length;

        if (currentModelToLoad) {
          filteredRemotes       = _.filter(remotes, function(remote){
            return (remote.get("type")===currentModelToLoad.type);
          });

          filteredRemotesLength = filteredRemotes.length;

          for (i=0; i<filteredRemotesLength; i++)
            if (currentModelToLoad.remotes[i])
              filteredRemotes[i].assignValues(currentModelToLoad.remotes[i].value);
            else
              filteredRemotes[i].assignValues(0);
          this.set("loadedModel", undefined);
          this.set("type", currentModelToLoad.type);
        }

        this.set("remotes", filteredRemotes);
        this.trigger("render:requested");
      },

      retrievePackages                : function(mainControlUnit) {
        var that = this;
        var mcuPackageClassId = mainControlUnit.get("packageClassId");
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(403, function(data) {
          var fetchedRemotes         = data.packages;
          var fetchedRemotesLength   = fetchedRemotes.length;
          var filteredRemotes        = [];
          var filteredRemotesLength  = 0;
          var type                   = "ir";
          var i;

          //Adding compatibilities to the retrieved packages
          for (i=0; i<fetchedRemotesLength; i++) {
            switch(fetchedRemotes[i].packageClassId) {
              case "4022" : fetchedRemotes[i].mcuCompatibility = ["4002", "4007", "4001", "4003", "4015", "4004", "4005"];
                            fetchedRemotes[i].type             =  "ir";
                            break;
              case "4024" :
              case "4025" :
              case "4026" : fetchedRemotes[i].mcuCompatibility = ["4008", "4009", "4006", "4010", "4007", "4015", "4004", "4005", "4508", "4000"];
                            fetchedRemotes[i].type             =  "tp";
                            break;
            }
          }

          that.set("fetchedRemotes", fetchedRemotes);

          //Filter uncompatible packages
          filteredRemotes = fetchedRemotes;

          filteredRemotes =_.filter(filteredRemotes, function(remote)
          {
            if (_.indexOf(remote.mcuCompatibility, mcuPackageClassId)!==-1)
              return true;
            else
              return false;
          });

          filteredRemotesLength = filteredRemotes.length;
          for(i=0; i<filteredRemotesLength; i++)
          {
            if (filteredRemotes[i].type==="tp")
            {
              type = "tp";
              break;
            }

          }

          //Retrieving products for this package
          var eventAggregator         = that.get("sectionEventAggregator");
          for (i=0; i<filteredRemotesLength; i++)
           filteredRemotes[i] = new remoteControlPackageModel(_.extend(filteredRemotes[i], {sectionEventAggregator : eventAggregator}));

          that.set("type", type, {silent: true});
          that.set("fetchedRemotes", filteredRemotes);
          that.filterPackages(that.get("type"));
        });
      },

      disableSection                  : function() {
        var that = this;
        this.set("enabled",false);
        this.get("contentView").disableSection();
        this.get("titleBarView").removeLabel();
        if(this.get("contentView").isOpen())
          this.get("titleBarView").disable();
      },

      enableSection                   : function() {
        var that = this;
        this.set("enabled",true);
        this.get("contentView").enableSection();
      },

      deliverModel                    : function() {
         var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
             remotes                  = this.get("remotes"), product;
         var i=0, j=0;

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.remoteControls = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.remoteControls = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.remoteControls = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.remoteControls = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.remoteControls = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.remoteControls = this;
              break;
          };
        BticinoS4B.Instances.Models.ApplicationModel.set("remoteControls", this);

        if (remotes) {
          for (i=0; i<remotes.length; i++) {
            for (j=0; j<remotes[i].get("products").length; j++) {
              dataProvider.addItems("externalItems", {
                productCode       : remotes[i].get("products")[j].get("productCode"),
                productLabel      : remotes[i].get("products")[j].get("productLabel"),
                packageClassLabel: remotes[i].get("products")[j].get("packageClassLabel"),
                quantity          : remotes[i].get("products")[j].get("value"),
                price             : remotes[i].get("products")[j].get("price")
              });
            }

            for (j=0; j<remotes[i].get("secondaryProducts").length; j++) {
              dataProvider.addItems("externalItems", {
                productCode       : remotes[i].get("secondaryProducts")[j].productCode,
                productLabel      : remotes[i].get("secondaryProducts")[j].productLabel,
                packageClassLabel: remotes[i].get("secondaryProducts")[j].packageClassLabel,
                quantity          : remotes[i].get("secondaryProducts")[j].value,
                price             : remotes[i].get("secondaryProducts")[j].price
              });
            }
          }
        }
      },

      loadProject                     : function(model) {
        if (model && model.remoteControls)
          this.set("loadedModel", model.remoteControls);
      }
    })
  });

  // Required, return the module for AMD compliance
  return remoteControls;

});